import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import axios from 'axios';
import Swal from 'sweetalert2';
import Select from 'react-select';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Topbar from '../../layouts/Topbar';
import Sidebar from '../../layouts/Sidebar';
import apiConfig, { API_BASE_URL as NAMED_API_BASE_URL } from '../../../config/api';

const API_BASE_URL = typeof apiConfig === 'string' ? apiConfig : NAMED_API_BASE_URL || 'https://pms.burrayhr.com';

const quarterOptions = [
    { value: 'Q1', label: 'Quarter 1' },
    { value: 'Q2', label: 'Quarter 2' },
    { value: 'Q3', label: 'Quarter 3' },
    { value: 'Q4', label: 'Quarter 4' },
    { value: 'Quarterly', label: 'Quarterly' },
    { value: 'Weekly', label: 'Weekly' },
    { value: 'Bi-Weekly', label: 'Bi-Weekly' },
    { value: 'Monthly', label: 'Monthly' },
    { value: 'Semi-Annually', label: 'Semi-Annually' },
    { value: 'Annually', label: 'Annually' },
];

const monthOptions = [
    { value: 1, label: 'January' },
    { value: 2, label: 'February' },
    { value: 3, label: 'March' },
    { value: 4, label: 'April' },
    { value: 5, label: 'May' },
    { value: 6, label: 'June' },
    { value: 7, label: 'July' },
    { value: 8, label: 'August' },
    { value: 9, label: 'September' },
    { value: 10, label: 'October' },
    { value: 11, label: 'November' },
    { value: 12, label: 'December' },
];

const performanceStandardOptions = [
    { value: 'Monthly', label: 'MONTHLY' },
    { value: 'Quarterly', label: 'QUARTELY' },
    { value: 'Always', label: 'ALWAYS' },
    { value: 'As and when necessary', label: 'AS AND WHEN NECESSARY' },
    { value: 'As and when required', label: 'AS AND WHEN REQUIRED' },
    { value: 'Daily', label: 'DAILY' },
    { value: 'Annually in line with policies and procedures', label: 'ANNUALLY IN LINE WITH POLICIES AND PROCEDURES' },
    { value: 'Quarterly accurate records daily', label: 'QUARTELY ACCURATE RECORDS DAILY' }
];

const selectStyles = {
    control: (base) => ({ ...base, minHeight: '38px', borderRadius: '0.375rem' }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 })
};

const HODGoals = () => {
    const baseUrl = API_BASE_URL;
    const navigate = useNavigate();

    const [goals, setGoals] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [expandedActivities, setExpandedActivities] = useState({});

    // Goal Details Modal
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedGoal, setSelectedGoal] = useState(null);

    // Progress History
    const [progressHistory, setProgressHistory] = useState([]);
    const [progressLoading, setProgressLoading] = useState(false);
    const [progressError, setProgressError] = useState(null);

    // Progress Update Modal
    const [progressModalOpen, setProgressModalOpen] = useState(false);
    const [progressForm, setProgressForm] = useState({ status: 'in_progress', comments: '', score: '', file: null });
    const [progressSubmitting, setProgressSubmitting] = useState(false);
    const [progressSubmitError, setProgressSubmitError] = useState(null);

    // Edit Goal Modal
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [editForm, setEditForm] = useState({
        key_result_area: null,
        activity: '',
        metric: '',
        stakeholder: '',
        performance_standard: null,
        quarter: null,
        year: new Date().getFullYear(),
        week: '',
        month: null
    });
    const [editLoading, setEditLoading] = useState(false);
    const [editError, setEditError] = useState(null);

    // Filtering states
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [availableYears, setAvailableYears] = useState([]);
    const [selectedQuarter, setSelectedQuarter] = useState('');
    const [selectedStatus, setSelectedStatus] = useState('active');

    // KRAs for edit dropdown
    const [kras, setKras] = useState([]);
    const [fetchingKRAs, setFetchingKRAs] = useState(false);

    const toggleActivityExpansion = (goalId) => {
        setExpandedActivities(prev => ({
            ...prev,
            [goalId]: !prev[goalId]
        }));
    };

    const fetchProgressHistory = async (goalId) => {
        setProgressLoading(true);
        setProgressError(null);
        try {
            const token = Cookies.get('token');
            const response = await axios.get(`${baseUrl}/api/goals/${goalId}/progress/`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            const data = response.data;
            setProgressHistory(Array.isArray(data) ? data : (data.results || []));
        } catch (err) {
            console.error('Error fetching progress history:', err);
            setProgressError(err.message || 'Could not load progress history.');
        } finally {
            setProgressLoading(false);
        }
    };

    const [showDocPreview, setShowDocPreview] = useState(false);
    
      const getGoalDocumentUrl = (goal) => {
        if (!goal || !goal.goal_documents) return null;
        const docs = goal.goal_documents;
        let path = null;
        if (typeof docs === 'object') {
          path = docs.document || docs.file || docs.url;
        } else if (typeof docs === 'string') {
          path = docs;
        }
    
        if (!path) return null;
        if (path.startsWith('http://') || path.startsWith('https://')) {
          return path;
        }
        return `${baseUrl}${path.startsWith('/') ? '' : '/'}${path}`;
      };

    const handleViewGoal = (goal) => {
        setSelectedGoal(goal);
        setModalOpen(true);
        fetchProgressHistory(goal.id);
    };

    const closeModal = () => {
        setModalOpen(false);
        setSelectedGoal(null);
    };

    const openProgressModal = () => {
        setProgressForm({ status: 'in_progress', comments: '', score: '', file: null });
        setProgressSubmitError(null);
        setProgressModalOpen(true);
    };

    const closeProgressModal = () => {
        setProgressModalOpen(false);
    };

    const handleProgressFormChange = (e) => {
        const { name, value, files } = e.target;
        if (name === 'file') {
            setProgressForm(prev => ({ ...prev, file: files && files[0] ? files[0] : null }));
            return;
        }
        setProgressForm(prev => ({ ...prev, [name]: value }));
    };

    const handleProgressSubmit = async (e) => {
        e.preventDefault();

        if (progressForm.status === 'completed' && progressForm.score && Number(progressForm.score) > Number(selectedGoal.metric)) {
            setProgressSubmitError(`Score cannot be greater than the goal metric (${selectedGoal.metric}).`);
            return;
        }

        setProgressSubmitting(true);
        setProgressSubmitError(null);
        try {
            const token = Cookies.get('token');
            await axios.post(`${baseUrl}/api/goals/${selectedGoal.id}/progress/`,
                { status: progressForm.status, comments: progressForm.comments, score: progressForm.score },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                }
            );

            if (progressForm.status === 'completed' && progressForm.file) {
                const filePayload = new FormData();
                filePayload.append('performance_goal', selectedGoal.id);
                filePayload.append('document', progressForm.file);

                await axios.post(`${baseUrl}/api/goal-documents/`, filePayload, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                    },
                });
            }

            setProgressModalOpen(false);
            await fetchProgressHistory(selectedGoal.id);

            const updatedGoalRes = await axios.get(`${baseUrl}/api/goals/${selectedGoal.id}/`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            const updatedGoal = updatedGoalRes.data;
            setGoals(prevGoals => prevGoals.map(g => (g.id === updatedGoal.id ? updatedGoal : g)));
            setSelectedGoal(updatedGoal);
            toast.success('Progress updated successfully!');
        } catch (err) {
            console.error('Error submitting progress:', err);
            setProgressSubmitError(err.message || 'Could not update progress.');
        } finally {
            setProgressSubmitting(false);
        }
    };

    const handleDeleteGoal = async (goal) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'This will permanently delete the goal.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        });
        if (result.isConfirmed) {
            try {
                const token = Cookies.get('token');
                await axios.delete(`${baseUrl}/api/goals/${goal.id}/`, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                });
                setGoals(prevGoals => prevGoals.filter(g => g.id !== goal.id));
                Swal.fire('Deleted!', 'The goal has been deleted.', 'success');
            } catch (err) {
                console.error('Error deleting goal:', err);
                Swal.fire('Error', err.message || 'Failed to delete goal.', 'error');
            }
        }
    };

    // Fetch KRAs for edit dropdown
    useEffect(() => {
        const fetchKRAs = async () => {
            setFetchingKRAs(true);
            try {
                const token = Cookies.get('token');
                const response = await axios.get(`${baseUrl}/api/key-result-areas/`, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                });
                setKras(Array.isArray(response.data) ? response.data : []);
            } catch (err) {
                console.error('Error fetching KRAs:', err);
            } finally {
                setFetchingKRAs(false);
            }
        };
        fetchKRAs();
    }, [baseUrl]);

    const kraOptions = kras.map(kra => ({ value: kra.id, label: kra.name }));

    const openEditModal = (goal) => {
        let kraOption = null;
        if (goal.key_result_area) {
            if (typeof goal.key_result_area === 'object' && goal.key_result_area !== null && 'id' in goal.key_result_area) {
                kraOption = kraOptions.find(k => k.value === goal.key_result_area.id) || null;
            } else if (typeof goal.key_result_area === 'number' || typeof goal.key_result_area === 'string') {
                kraOption = kraOptions.find(k => k.value === goal.key_result_area) || null;
            }
        }

        const quarterOption = goal.quarter ? quarterOptions.find(q => q.value === goal.quarter) || null : null;
        const performanceStandardOption = goal.performance_standard ? performanceStandardOptions.find(p => p.value === goal.performance_standard) || null : null;
        const monthOption = goal.month ? monthOptions.find(m => m.value === goal.month) || null : null;

        setEditForm({
            key_result_area: kraOption,
            activity: goal.activity || '',
            metric: goal.metric || '',
            stakeholder: goal.stakeholder || '',
            performance_standard: performanceStandardOption,
            quarter: quarterOption,
            year: goal.year || new Date().getFullYear(),
            week: goal.week || '',
            month: monthOption,
        });
        setEditError(null);
        setSelectedGoal(goal);
        setEditModalOpen(true);
    };

    const closeEditModal = () => {
        setEditModalOpen(false);
    };

    const handleEditFormChange = (e) => {
        setEditForm({ ...editForm, [e.target.name]: e.target.value });
    };

    const handleEditSelectChange = (selected, { name }) => {
        setEditForm({ ...editForm, [name]: selected });
    };

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        setEditLoading(true);
        setEditError(null);
        try {
            const token = Cookies.get('token');
            const response = await axios.put(`${baseUrl}/api/goals/${selectedGoal.id}/`, {
                key_result_area_id: editForm.key_result_area ? editForm.key_result_area.value : null,
                activity: editForm.activity,
                metric: parseInt(editForm.metric, 10),
                stakeholder: editForm.stakeholder,
                performance_standard: editForm.performance_standard ? editForm.performance_standard.value : null,
                quarter: editForm.quarter ? editForm.quarter.value : null,
                week: editForm.quarter?.value === 'Weekly' ? parseInt(editForm.week, 10) : null,
                month: editForm.quarter?.value === 'Monthly' ? (editForm.month ? parseInt(editForm.month.value, 10) : null) : null,
                year: editForm.year || new Date().getFullYear(),
            }, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });

            const updatedGoal = response.data;
            setGoals(prevGoals => prevGoals.map(g => (g.id === updatedGoal.id ? updatedGoal : g)));
            setSelectedGoal(updatedGoal);
            setEditModalOpen(false);
            toast.success('Goal updated successfully!');
        } catch (err) {
            console.error('Error updating goal:', err);
            setEditError(err.message || 'Could not update goal.');
        } finally {
            setEditLoading(false);
        }
    };

    // Fetch User Goals
    useEffect(() => {
        const fetchProfile = async () => {
            setLoading(true);
            setError(null);
            try {
                const token = Cookies.get('token');
                const response = await axios.get(`${baseUrl}/api/users/me`, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                });
                setGoals(Array.isArray(response?.data?.employee?.goals) ? response?.data?.employee?.goals : []);
            } catch (err) {
                console.error('Error fetching profile goals:', err);
                setError(err.response?.data?.message || err.message || 'Failed to fetch goals.');
            } finally {
                setLoading(false);
            }
        };
        fetchProfile();
    }, [baseUrl]);

    // Extract Available Years
    useEffect(() => {
        if (goals && goals.length > 0) {
            const uniqueYears = [...new Set(goals
                .map(goal => goal.year)
                .filter(year => year !== null && year !== undefined)
            )].sort((a, b) => b - a);

            if (uniqueYears.length > 0) {
                setAvailableYears(uniqueYears);
            }
        } else {
            setAvailableYears([]);
        }
    }, [goals]);

    const renderApprovalBadge = (status) => {
        switch (status?.toLowerCase()) {
            case 'approved':
                return (
                    <span className="badge bg-success-transparent text-success d-inline-flex align-items-center gap-1">
                        <i className="ti ti-circle-check-filled"></i> Approved
                    </span>
                );
            case 'rejected':
                return (
                    <span className="badge bg-danger-transparent text-danger d-inline-flex align-items-center gap-1">
                        <i className="ti ti-circle-x-filled"></i> Rejected
                    </span>
                );
            case 'pending':
            default:
                return (
                    <span className="badge bg-warning-transparent text-warning d-inline-flex align-items-center gap-1">
                        <i className="ti ti-clock"></i> Pending
                    </span>
                );
        }
    };

    return (
        <div data-sidebar-skin="dark" data-header-skin="light" data-navbar-brand-skin="dark" data-sidebar-state="expand">
            <ToastContainer position="top-right" autoClose={3000} />
            <Topbar />
            <Sidebar />
            <div className="page-wrapper">
                <div className="content pb-0">
                    {/* Page Header */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2 mb-md-0">
                            <h4 className="mb-0">My Key Performance Indicators</h4>
                            <p className="text-muted mb-0 fs-13">View and manage your personal KPIs</p>
                        </div>

                        {/* Filter Bar */}
                        <div className="d-flex align-items-center gap-2 flex-wrap">
                            {/* Active / Completed Toggle */}
                            <div className="btn-group btn-group-sm" role="group">
                                <button
                                    type="button"
                                    className={`btn ${selectedStatus === 'active' ? 'btn-primary' : 'btn-outline-secondary'}`}
                                    onClick={() => setSelectedStatus('active')}
                                >
                                    Active
                                </button>
                                <button
                                    type="button"
                                    className={`btn ${selectedStatus === 'completed' ? 'btn-success' : 'btn-outline-secondary'}`}
                                    onClick={() => setSelectedStatus('completed')}
                                >
                                    Completed
                                </button>
                            </div>

                            {/* Year Filter */}
                            <div className="d-flex align-items-center gap-1">
                                <label className="form-label mb-0 fs-13 text-muted">Year:</label>
                                <select
                                    value={selectedYear}
                                    onChange={(e) => setSelectedYear(parseInt(e.target.value, 10))}
                                    className="form-select form-select-sm"
                                    style={{ width: 'auto' }}
                                >
                                    {(availableYears.length ? availableYears : [selectedYear])
                                        .sort((a, b) => b - a)
                                        .map(y => (
                                            <option key={y} value={y}>{y}</option>
                                        ))}
                                </select>
                            </div>

                            {/* Quarter Filter */}
                            <div className="d-flex align-items-center gap-1">
                                <label className="form-label mb-0 fs-13 text-muted">Quarter:</label>
                                <select
                                    value={selectedQuarter}
                                    onChange={(e) => setSelectedQuarter(e.target.value)}
                                    className="form-select form-select-sm"
                                    style={{ width: 'auto' }}
                                >
                                    <option value="">All</option>
                                    <option value="Q1">Q1</option>
                                    <option value="Q2">Q2</option>
                                    <option value="Q3">Q3</option>
                                    <option value="Q4">Q4</option>
                                    <option value="Quarterly">Quarterly</option>
                                    <option value="Bi-Weekly">Bi-Weekly</option>
                                    <option value="Monthly">Monthly</option>
                                    <option value="Semi-Annually">Semi-Annually</option>
                                    <option value="Annually">Annually</option>
                                    <option value="Weekly">Weekly</option>
                                </select>
                            </div>

                            <button
                                className="btn btn-primary btn-sm d-inline-flex align-items-center gap-1"
                                onClick={() => navigate('/hod/create-goal')}
                            >
                                <i className="ti ti-plus fs-16"></i>
                                <span>Create KPI</span>
                            </button>
                        </div>
                    </div>

                    {/* Table Container */}
                    <div className="card shadow-sm border-0 mb-4">
                        <div className="card-body p-0">
                            {loading ? (
                                <div className="text-center py-5">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                    <p className="text-muted mt-2">Loading KPIs...</p>
                                </div>
                            ) : error ? (
                                <div className="alert alert-danger m-3">{error}</div>
                            ) : (
                                <div className="table-responsive">
                                    <table className="table table-hover align-middle mb-0">
                                        <thead className="table-light">
                                            <tr>
                                                <th>Activity</th>
                                                <th>Stakeholder</th>
                                                <th className="text-center">KPI Metric</th>
                                                <th className="text-center">Approval Status</th>
                                                <th className="text-center">Period</th>
                                                <th className="text-center">RAG Indicator</th>
                                                <th className="text-center">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(() => {
                                                const filteredGoals = goals
                                                    .filter(g => (g.year !== undefined && g.year !== null) ? Number(g.year) === Number(selectedYear) : true)
                                                    .filter(goal => !selectedQuarter || goal.quarter === selectedQuarter)
                                                    .filter(goal => {
                                                        if (selectedStatus === 'completed') {
                                                            return goal.status === 'completed';
                                                        }
                                                        return (
                                                            goal.status === 'not_started' ||
                                                            goal.status === 'in_progress' ||
                                                            goal.status == null
                                                        );
                                                    });

                                                if (filteredGoals.length === 0) {
                                                    return (
                                                        <tr>
                                                            <td colSpan={7} className="text-center py-4 text-muted">
                                                                No KPIs found for the selected filters.
                                                            </td>
                                                        </tr>
                                                    );
                                                }

                                                const groupedByKra = filteredGoals.reduce((acc, goal) => {
                                                    const kraName =
                                                        (goal.key_result_area && typeof goal.key_result_area === 'object'
                                                            ? goal.key_result_area.name
                                                            : goal.key_result_area) || 'Uncategorized';
                                                    if (!acc[kraName]) acc[kraName] = [];
                                                    acc[kraName].push(goal);
                                                    return acc;
                                                }, {});

                                                return Object.entries(groupedByKra).map(([kraName, kraGoals]) => (
                                                    <React.Fragment key={kraName}>
                                                        <tr className="table-secondary">
                                                            <td colSpan={7} className="fw-bold text-dark py-2">
                                                                <i className="ti ti-folder me-2 text-primary"></i>
                                                                {kraName}{' '}
                                                                <span className="fw-normal text-muted fs-13 ms-1">
                                                                    (KRA Weight:{' '}
                                                                    {kraGoals?.[0]?.key_result_area?.percentage ??
                                                                        kraGoals?.[0]?.kra?.percentage ??
                                                                        kraGoals?.[0]?.percentage ?? 0}
                                                                    %)
                                                                </span>
                                                            </td>
                                                        </tr>
                                                        {kraGoals.map((goal, idx) => {
                                                            let activityStr = typeof goal.activity === 'object' && goal.activity !== null
                                                                ? JSON.stringify(goal.activity)
                                                                : (goal.activity || '[No Activity]');
                                                            const expandKey = goal.id || `${kraName}-${idx}`;
                                                            const isExpanded = expandedActivities[expandKey];

                                                            return (
                                                                <tr key={goal.id || `${kraName}-${idx}`}>
                                                                    <td>
                                                                        {activityStr.length > 35 ? (
                                                                            <span>
                                                                                {isExpanded ? activityStr : `${activityStr.slice(0, 35)}...`}
                                                                                <button
                                                                                    type="button"
                                                                                    onClick={() => toggleActivityExpansion(expandKey)}
                                                                                    className="btn btn-link p-0 ms-1 text-decoration-none fs-12 fw-semibold"
                                                                                >
                                                                                    {isExpanded ? ' [less]' : ' [more]'}
                                                                                </button>
                                                                            </span>
                                                                        ) : (
                                                                            activityStr
                                                                        )}
                                                                    </td>
                                                                    <td>{goal.stakeholder || '-'}</td>
                                                                    <td className="text-center fw-semibold">{goal.metric !== undefined ? `${goal.metric}%` : '-'}</td>
                                                                    <td className="text-center">{renderApprovalBadge(goal.approval_status)}</td>
                                                                    <td className="text-center fw-medium">{goal.quarter || '-'}</td>
                                                                    <td className="text-center">
                                                                        <div
                                                                            className="d-inline-flex align-items-center px-2 py-1 rounded text-white fs-12 fw-semibold"
                                                                            style={{ backgroundColor: goal.progress_indicator || '#6c757d' }}
                                                                        >
                                                                            {goal.rag_color || 'Status'}
                                                                        </div>
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <div className="d-flex align-items-center justify-content-center gap-1">
                                                                            <button
                                                                                className="btn btn-sm btn-icon btn-light"
                                                                                title="Edit"
                                                                                onClick={() => openEditModal(goal)}
                                                                            >
                                                                                <i className="ti ti-edit fs-16 text-muted"></i>
                                                                            </button>
                                                                            <button
                                                                                className="btn btn-sm btn-icon btn-light"
                                                                                title="Delete"
                                                                                onClick={() => handleDeleteGoal(goal)}
                                                                            >
                                                                                <i className="ti ti-trash fs-16 text-danger"></i>
                                                                            </button>
                                                                            <button
                                                                                className="btn btn-sm btn-icon btn-light"
                                                                                title="View Details"
                                                                                onClick={() => handleViewGoal(goal)}
                                                                            >
                                                                                <i className="ti ti-eye fs-16 text-muted"></i>
                                                                            </button>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </React.Fragment>
                                                ));
                                            })()}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* View Details & Progress History Modal */}
            {modalOpen && selectedGoal && (
                <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content border-0 shadow">
                            <div className="modal-header">
                                <h5 className="modal-title fw-bold">KPI Details</h5>
                                <button type="button" className="btn-close" onClick={closeModal}></button>
                            </div>
                            <div className="modal-body">
                                <div className="table-responsive border rounded mb-4">
                                    <table className="table table-bordered mb-0">
                                        <tbody>
                                            <tr>
                                                <th className="bg-light w-35 text-muted">Key Result Area</th>
                                                <td className="fw-medium">{selectedGoal.key_result_area?.name || selectedGoal.key_result_area || '[No KRA]'}</td>
                                            </tr>
                                            <tr>
                                                <th className="bg-light text-muted">KRA Weight</th>
                                                <td className="fw-medium">{selectedGoal.key_result_area?.percentage || selectedGoal.percentage || 0}%</td>
                                            </tr>
                                            <tr>
                                                <th className="bg-light text-muted">Activity / KPI</th>
                                                <td>{typeof selectedGoal.activity === 'object' && selectedGoal.activity !== null ? JSON.stringify(selectedGoal.activity) : (selectedGoal.activity || '[No Activity]')}</td>
                                            </tr>
                                            <tr>
                                                <th className="bg-light text-muted">KPI Metric</th>
                                                <td>{selectedGoal.metric}%</td>
                                            </tr>
                                            <tr>
                                                <th className="bg-light text-muted">Stakeholder</th>
                                                <td>{selectedGoal.stakeholder || '-'}</td>
                                            </tr>
                                            <tr>
                                                <th className="bg-light text-muted">Period</th>
                                                <td>{selectedGoal.quarter || '-'}</td>
                                            </tr>
                                            <tr>
                                                <th className="bg-light text-muted">RAG Indicator</th>
                                                <td>
                                                    <span
                                                        className="badge text-white py-1 px-2"
                                                        style={{ backgroundColor: selectedGoal.progress_indicator || '#6c757d' }}
                                                    >
                                                        {selectedGoal.rag_color || 'Status'}
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th className="bg-light text-muted">Status</th>
                                                <td>
                                                    {selectedGoal.status
                                                        ? selectedGoal.status.charAt(0).toUpperCase() + selectedGoal.status.slice(1).replace(/_/g, ' ')
                                                        : 'N/A'}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th className="bg-light text-muted">Approval Status</th>
                                                <td>{renderApprovalBadge(selectedGoal.approval_status)}</td>
                                            </tr>
                                            {selectedGoal.approval_status === 'rejected' && selectedGoal.rejected_reason && (
                                                <tr>
                                                    <th className="bg-light text-muted">Rejection Reason</th>
                                                    <td className="text-danger fw-medium">{selectedGoal.rejected_reason}</td>
                                                </tr>
                                            )}
                                            {(() => {
                                                const docUrl = getGoalDocumentUrl(selectedGoal);
                                                if (!docUrl) return null;
                                                const isImage = /\.(jpg|jpeg|png|gif|webp|svg)(\?.*)?$/i.test(docUrl);

                                                return (
                                                    <>
                                                        <tr>
                                                            <th className="text-muted fw-semibold fs-14">Attached Document:</th>
                                                            <td>
                                                                <div className="d-flex align-items-center gap-2 flex-wrap">
                                                                    <button
                                                                        type="button"
                                                                        className={`btn btn-sm ${showDocPreview ? 'btn-primary' : 'btn-outline-primary'} d-inline-flex align-items-center gap-1`}
                                                                        onClick={() => setShowDocPreview(!showDocPreview)}
                                                                    >
                                                                        <i className={`ti ${showDocPreview ? 'ti-eye-off' : 'ti-eye'}`} />
                                                                        {showDocPreview ? 'Hide Document Preview' : 'View Document On Site'}
                                                                    </button>
                                                                    <a
                                                                        href={docUrl}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        className="btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-1"
                                                                    >
                                                                        <i className="ti ti-external-link" /> Open in New Tab
                                                                    </a>
                                                                    <a
                                                                        href={docUrl}
                                                                        download
                                                                        className="btn btn-sm btn-outline-success d-inline-flex align-items-center gap-1"
                                                                    >
                                                                        <i className="ti ti-download" /> Download
                                                                    </a>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        {showDocPreview && (
                                                            <tr>
                                                                <td colSpan={2} className="p-0 border-0">
                                                                    <div className="p-3 bg-light border-top border-bottom rounded-bottom mt-2">
                                                                        <div className="d-flex align-items-center justify-content-between mb-2">
                                                                            <span className="fw-semibold text-dark fs-14">
                                                                                <i className="ti ti-file-text me-1 text-primary" />
                                                                                Document Preview (On Site)
                                                                            </span>
                                                                            <span className="text-muted fs-12">{docUrl.split('/').pop()}</span>
                                                                        </div>
                                                                        {isImage ? (
                                                                            <div className="text-center p-2 bg-white rounded border">
                                                                                <img
                                                                                    src={docUrl}
                                                                                    alt="Goal Document"
                                                                                    className="img-fluid rounded shadow-sm"
                                                                                    style={{ maxHeight: '500px', objectFit: 'contain' }}
                                                                                />
                                                                            </div>
                                                                        ) : (
                                                                            <div className="ratio ratio-16x9 rounded border overflow-hidden shadow-sm" style={{ minHeight: '450px' }}>
                                                                                <iframe
                                                                                    src={docUrl}
                                                                                    title="Goal Document Preview"
                                                                                    className="w-100 h-100 border-0"
                                                                                />
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </>
                                                );
                                            })()}
                                        </tbody>
                                    </table>
                                </div>

                                {/* Progress History Section (Approved Goals) */}
                                {selectedGoal.approval_status === 'approved' && (
                                    <div className="border-top pt-3">
                                        <div className="d-flex align-items-center justify-content-between mb-3">
                                            <h6 className="fw-bold text-dark mb-0">Progress History</h6>
                                            <button
                                                className="btn btn-sm btn-primary"
                                                onClick={openProgressModal}
                                                disabled={selectedGoal.status === 'completed'}
                                            >
                                                <i className="ti ti-plus me-1"></i> Update Progress
                                            </button>
                                        </div>

                                        <div className="table-responsive border rounded">
                                            <table className="table table-hover align-middle mb-0">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th>Comment</th>
                                                        <th>Status</th>
                                                        <th>Date</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {(!selectedGoal.progress_history || selectedGoal.progress_history.length === 0) ? (
                                                        <tr>
                                                            <td colSpan={3} className="text-center py-3 text-muted">
                                                                No progress history.
                                                            </td>
                                                        </tr>
                                                    ) : (
                                                        selectedGoal.progress_history.map((ph, i) => (
                                                            <tr key={ph.id || i}>
                                                                <td>{ph.comments}</td>
                                                                <td className="text-capitalize">{ph.status}</td>
                                                                <td>
                                                                    {ph.reported_at
                                                                        ? new Date(ph.reported_at).toLocaleString("en-US", {
                                                                            year: "numeric",
                                                                            month: "short",
                                                                            day: "2-digit",
                                                                            hour: "2-digit",
                                                                            minute: "2-digit",
                                                                        })
                                                                        : "-"}
                                                                </td>
                                                            </tr>
                                                        ))
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="modal-footer bg-light">
                                <button type="button" className="btn btn-secondary" onClick={closeModal}>
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Update Progress Modal */}
            {progressModalOpen && selectedGoal && (
                <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1060 }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content border-0 shadow">
                            <div className="modal-header">
                                <h5 className="modal-title fw-bold">Update Goal Progress</h5>
                                <button type="button" className="btn-close" onClick={closeProgressModal}></button>
                            </div>
                            <form onSubmit={handleProgressSubmit}>
                                <div className="modal-body">
                                    <div className="mb-3">
                                        <label htmlFor="progress-status" className="form-label fw-medium">
                                            Status <span className="text-danger">*</span>
                                        </label>
                                        <select
                                            id="progress-status"
                                            name="status"
                                            value={progressForm.status}
                                            onChange={handleProgressFormChange}
                                            className="form-select"
                                            required
                                            disabled={progressSubmitting}
                                        >
                                            <option value="in_progress">In Progress</option>
                                            <option value="completed">Completed</option>
                                        </select>
                                    </div>

                                    {progressForm.status === 'completed' && (
                                        <div className="mb-3">
                                            <label htmlFor="progress-score" className="form-label fw-medium">
                                                Final Score (Max: {selectedGoal.metric}) <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                id="progress-score"
                                                name="score"
                                                type="number"
                                                min={0}
                                                max={selectedGoal.metric}
                                                value={progressForm.score}
                                                onChange={handleProgressFormChange}
                                                className="form-control"
                                                placeholder={`Enter score (0 - ${selectedGoal.metric})`}
                                                required
                                                disabled={progressSubmitting}
                                            />
                                        </div>
                                    )}

                                    <div className="mb-3">
                                        <label htmlFor="progress-comments" className="form-label fw-medium">
                                            Deliverable / Comment <span className="text-danger">*</span>
                                        </label>
                                        <textarea
                                            id="progress-comments"
                                            name="comments"
                                            value={progressForm.comments}
                                            onChange={handleProgressFormChange}
                                            className="form-control"
                                            rows={3}
                                            placeholder="Enter progress deliverables or comments..."
                                            required
                                            disabled={progressSubmitting}
                                        />
                                    </div>

                                    {progressForm.status === 'completed' && (
                                        <div className="mb-3">
                                            <label htmlFor="progress-file" className="form-label fw-medium">
                                                Supporting Document <span className="text-muted fw-normal">(Optional)</span>
                                            </label>
                                            <input
                                                type="file"
                                                id="progress-file"
                                                name="file"
                                                onChange={handleProgressFormChange}
                                                className="form-control"
                                                disabled={progressSubmitting}
                                            />
                                        </div>
                                    )}

                                    {progressSubmitError && (
                                        <div className="alert alert-danger py-2 fs-13 mb-0">{progressSubmitError}</div>
                                    )}
                                </div>
                                <div className="modal-footer bg-light">
                                    <button
                                        type="button"
                                        className="btn btn-light"
                                        onClick={closeProgressModal}
                                        disabled={progressSubmitting}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="btn btn-primary d-flex align-items-center gap-2"
                                        disabled={progressSubmitting}
                                    >
                                        {progressSubmitting && <span className="spinner-border spinner-border-sm"></span>}
                                        <span>Submit Update</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {/* Edit Goal Modal */}
            {editModalOpen && selectedGoal && (
                <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1060 }}>
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content border-0 shadow">
                            <div className="modal-header">
                                <h5 className="modal-title fw-bold">Edit KPI</h5>
                                <button type="button" className="btn-close" onClick={closeEditModal}></button>
                            </div>
                            <form onSubmit={handleEditSubmit}>
                                <div className="modal-body">
                                    <div className="mb-3">
                                        <label className="form-label fw-medium">Year</label>
                                        <select
                                            name="year"
                                            value={editForm.year}
                                            onChange={handleEditFormChange}
                                            className="form-select"
                                            disabled={editLoading}
                                        >
                                            {Array.from({ length: 5 }, (_, i) => {
                                                const year = new Date().getFullYear() - 2 + i;
                                                return <option key={year} value={year}>{year}</option>;
                                            })}
                                        </select>
                                    </div>

                                    <div className="row g-3 mb-3">
                                        <div className="col-md-6">
                                            <label className="form-label fw-medium">Key Result Area</label>
                                            <Select
                                                name="key_result_area"
                                                value={editForm.key_result_area}
                                                onChange={handleEditSelectChange}
                                                options={kraOptions}
                                                placeholder={fetchingKRAs ? 'Loading KRAs...' : 'Select KRA'}
                                                classNamePrefix="react-select"
                                                isDisabled={editLoading || fetchingKRAs}
                                                styles={selectStyles}
                                                menuPortalTarget={document.body}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-medium">Period</label>
                                            <Select
                                                name="quarter"
                                                value={editForm.quarter}
                                                onChange={handleEditSelectChange}
                                                options={quarterOptions}
                                                placeholder="Select Period"
                                                classNamePrefix="react-select"
                                                isDisabled={editLoading}
                                                styles={selectStyles}
                                                menuPortalTarget={document.body}
                                            />
                                        </div>
                                    </div>

                                    {(editForm.quarter?.value === 'Weekly' || editForm.quarter?.value === 'Bi-Weekly') && (
                                        <div className="mb-3">
                                            <label className="form-label fw-medium">Week Number</label>
                                            <input
                                                type="number"
                                                name="week"
                                                value={editForm.week}
                                                onChange={handleEditFormChange}
                                                className="form-control"
                                                placeholder="Enter week number (1-52)"
                                                min="1"
                                                max="52"
                                                disabled={editLoading}
                                            />
                                        </div>
                                    )}

                                    {editForm.quarter?.value === 'Monthly' && (
                                        <div className="mb-3">
                                            <label className="form-label fw-medium">Month</label>
                                            <Select
                                                name="month"
                                                value={editForm.month}
                                                onChange={handleEditSelectChange}
                                                options={monthOptions}
                                                placeholder="Select Month"
                                                classNamePrefix="react-select"
                                                isDisabled={editLoading}
                                                styles={selectStyles}
                                                menuPortalTarget={document.body}
                                            />
                                        </div>
                                    )}

                                    <div className="mb-3">
                                        <label className="form-label fw-medium">Activity / KPI</label>
                                        <textarea
                                            name="activity"
                                            value={editForm.activity}
                                            onChange={handleEditFormChange}
                                            required
                                            className="form-control"
                                            rows={3}
                                            disabled={editLoading}
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label fw-medium">Performance Standard</label>
                                        <Select
                                            name="performance_standard"
                                            value={editForm.performance_standard}
                                            onChange={handleEditSelectChange}
                                            options={performanceStandardOptions}
                                            placeholder="Select Performance Standard"
                                            classNamePrefix="react-select"
                                            isDisabled={editLoading}
                                            styles={selectStyles}
                                            menuPortalTarget={document.body}
                                        />
                                    </div>

                                    <div className="row g-3 mb-3">
                                        <div className="col-md-6">
                                            <label className="form-label fw-medium">Metric</label>
                                            <input
                                                type="number"
                                                name="metric"
                                                value={editForm.metric}
                                                onChange={handleEditFormChange}
                                                required
                                                className="form-control"
                                                min="0"
                                                disabled={editLoading}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-medium">Stakeholder</label>
                                            <input
                                                type="text"
                                                name="stakeholder"
                                                value={editForm.stakeholder}
                                                onChange={handleEditFormChange}
                                                required
                                                className="form-control"
                                                disabled={editLoading}
                                            />
                                        </div>
                                    </div>

                                    {editError && (
                                        <div className="alert alert-danger py-2 fs-13 mb-0">{editError}</div>
                                    )}
                                </div>
                                <div className="modal-footer bg-light">
                                    <button
                                        type="button"
                                        className="btn btn-light"
                                        onClick={closeEditModal}
                                        disabled={editLoading}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="btn btn-primary d-flex align-items-center gap-2"
                                        disabled={editLoading}
                                    >
                                        {editLoading && <span className="spinner-border spinner-border-sm"></span>}
                                        <span>Update KPI</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default HODGoals;